import React, {FC} from 'react';
import {Button, CopyField} from '../Components';
import {Dialog} from './Dialog';

interface WebhookSecretDialogProps {
  secret: string;
  /** True when this replaced an existing secret rather than creating the first one. */
  rotated: boolean;
  onClose: () => void;
}

export const WebhookSecretDialog: FC<WebhookSecretDialogProps> = ({secret, rotated, onClose}) => (
  <Dialog onCancel={onClose}>
    <div className="overflow-y-auto">
      <div className="mb-4 text-lg font-medium text-[#33364b]">{rotated ? 'New signing secret' : 'Signing secret'}</div>

      <CopyField label="Signing secret" value={secret} hint="Copy it now. This is the only time it will be displayed." />

      <div className="mt-6 flex justify-end">
        <Button size="small" label="Done" onClick={onClose} />
      </div>
    </div>
  </Dialog>
);
